module.exports = __webpack_public_path__ + "img/product-ketang-jbxl-03.5272675c.png";